module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/async/loaders/syncloader.js!./loaders/async/loaders/asyncloader.js!./loaders/async/loaders/syncloader.js!./loaders/async/a.js
 ** module id = 10
 ** module chunks = 0
 **/